// extracted by mini-css-extract-plugin
export default {"crd":"StatCard_crd__tGAw3","icon":"StatCard_icon__Yn8mF","title":"StatCard_title__fd+1V","count":"StatCard_count__e7Bc3"};